import React from "react";
import { graphql } from "gatsby";
import Header from "../components/Header";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Breadcrumbs from "../components/Breadcrumbs";
import { useIntl } from "gatsby-plugin-intl";
import SocialShareButtons from "../components/SocialShareButtons";
import "./posts.css";

//injecter de la data
const Posts = ({ data }) => {
  const post = data.markdownRemark;
  let featuredImg = getImage(
    post.frontmatter.featuredImage?.childImageSharp?.gatsbyImageData
  );

  const title = post.frontmatter.title;
  const titleLink = post.fields.slug;
  const metaDescription = post.frontmatter.metaDescription;
  const tags = post.frontmatter.tags;
  const intl = useIntl();
  const crumbs = [
    {
      link: "/blog/",
      label: intl.formatMessage({ id: "blog", defaultMessage: "Blog" }),
    },
    // Ajout du lien du tag avec le nom du tag comme libellé
    {
      link: `/tags/${tags}`,
      label: tags,
    },
    { link: titleLink, label: title },
  ];
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  return (
    <>
      <Header />

      <head>
      <meta name="google-adsense-account" content="ca-pub-9905478910617490"/>
        <meta charSet="UTF-8" />
        <title>{post.frontmatter.title}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content={metaDescription} />
        <link rel="sitemap" type="application/xml" title="Sitemap" href="https://exploremadeira.eu/sitemap.xml/sitemap-0.xml" />
      </head>
      <div className="containerPresentation">
        <Breadcrumbs crumbs={crumbs} />
        <SocialShareButtons url={currentUrl} />
      </div>

      <main className="containerPresentation">
        <article>
          <GatsbyImage image={featuredImg} alt={post.frontmatter.title} />

          <div dangerouslySetInnerHTML={{ __html: post.html }} />
        </article>
      </main>
    </>
  );
};
//requete query pour injecter de la data
export const query = graphql`
  query ($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title

        featuredImage {
          childImageSharp {
            gatsbyImageData(width: 800)
          }
        }
        metaDescription
        tags
      }
      fields {
        slug
      }
    }
  }
`;

export default Posts;
